/**
 * Function to generate the endpoint for getting list of leads in gradepro app.
 */
export const fetchAssessmentRequestsUrl = () =>
  '/auto-assessment/grade-pro/requests';

/**
 * Function to get all the filters for the grade pro listing screen.
 */
export const fetchAssessmentsFiltersUrl = () =>
  '/auto-assessment/grade-pro/filters';

/**
 * Function to get the details of a particular assessment request.
 */
export const fetchAssessmentRequestDetailsUrl = (sessionId: string) =>
  `/auto-assessment/grade-pro/requests/${sessionId}`;

/**
 * endpoint to be fetched for retake reasons options
 */
export const fetchRetakeReasonsUrl = () =>
  '/auto-assessment/grade-pro/retake-reasons';

/**
 * endpoint to call to update the status of an assessment request
 */
export const updateAssessmentRequestUrl = (sessionId: string) =>
  `/auto-assessment/grade-pro/requests/${sessionId}`;

/**
 * endpoint to unlock the request.
 */
export const unlockAssessmentRequestUrl = (sessionId: string) =>
  `/auto-assessment/grade-pro/requests/${sessionId}/release`;
